module.exports = __webpack_public_path__ + "media/images/subcategory-3ef1a2ab1fc41b76ae9bb184d7037529.png";